module.exports = __webpack_public_path__ + "media/images/category/feature/index/thum-coj_f-ff91c69697657dcd50387a5815d8877c.jpg";